// extracted by mini-css-extract-plugin
export default {"app":"app_app__MfBLz","app__title":"app_app__title__TPn5b"};